import React from 'react';

import classNames from 'classnames'

import styles from './statistic_grid.module.sass'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Title from './basic/title'
import Video from './basic/video'

import Counter from './misc/counter'
import Button from './basic/button'

function measureStringWidth(string, fontSize, fontFamily, letterSpacing) {
	const span = document.createElement('span')
	span.style.fontSize = fontSize
	span.style.fontFamily = fontFamily
	span.style.letterSpacing = letterSpacing
	span.textContent = string
	document.body.appendChild(span)
	const width = span.offsetWidth
	document.body.removeChild(span)
	return width
}

function StatisticGrid(props) {
	const isBiopharmaPage = window.location.href.includes('biopharma');
	const fields = props.fields

	function renderStat(stat, smaller) {
		return <Counter end={stat} repeat={false} seconds={.5} delay={Math.random() * .2} />
	}

	return <div className={classNames(styles.statistic_grid, styles[fields.style.value] || styles.default)}>
			<ScrollAnimation styles={styles}>
				<BlockWrapper {...props}>
					{fields.title && <Title theme="dark" fields={{
						title: fields.title,
						divider: true,
						heading_type: 'h2'
					}} />}
					<div className={classNames(styles.grid_wrapper)}>
						{fields.items && fields.items.map((stat, i) => {
							const smaller = stat.statistic.length > 10 ? true : false
							return <div className={classNames(styles.stat, {[styles.biopharma]: isBiopharmaPage})} key={i}>
								<div className={classNames(styles.title, smaller ? styles.smaller : '')}>
									{/* <span className={styles.statistic_placeholder}>{stat.statistic}</span> */}
									<div className={styles.statistic_value}>
										{/* <Stat value={stat.statistic} /> */}
										{renderStat(stat.statistic, smaller)}
										{/* {stat.statistic.toString().match(/^\D+$/) ? <span>{stat.statistic}</span> : null
										<Counter height={'70px'} mobileHeight={'50px'} width={`${stat.statistic.toString().length * 50}px`} mobileWidth={'50px'} end={stat.statistic} repeat={false} seconds={1} /> */}
									</div>
								</div>
								<div className={styles.description} dangerouslySetInnerHTML={{ __html: stat.description}} />
							</div>
						})}
						{fields.button && <Button fields={{button: {url: fields.button.url, title: fields.button.title}}} color={fields.background_video ? 'white' : 'green'} className={styles.button}>{fields.button.title}</Button>}
					</div>
					<div className={styles.background_image} style={{backgroundImage: `url(${fields.background_image.url})`}}>
						{fields.background_video && <Video settings={{controls: false, autoplay: true, muted: true, loop: true, loading: 'eager'}} {...fields.background_video} className={styles.background_video} />}
					</div>
				</BlockWrapper>
			</ScrollAnimation>
	</div>
}

export default StatisticGrid